import { useState, useEffect } from "react";
import axios from "axios";

const SendBulkEmail = () => {
  const [emails, setEmails] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  // Fetch all emails when component loads
  useEffect(() => {
    const fetchEmails = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_DOMAIN ?? ""}/api/auth/user-contacts`
        );
        const emailList = response.data.map((user) => user.email).join(",");
        setEmails(emailList);
      } catch (error) {
        console.error("Error fetching emails:", error);
      }
    };

    fetchEmails();
  }, []);

  const sendEmails = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_DOMAIN ?? ""}/api/auth/send-email`,
        {
          emails: emails.split(","),
          subject,
          message,
        }
      );
      console.log("Email result==>", res.data);
      alert("Emails sent successfully!");
    } catch (error) {
      console.error("Email Error:", error);
      alert("Failed to send emails");
    }
  };

  return (
    <div className="row mail-bx">
      <form>
        <div className="mb-1 mb-3">
          <textarea
            className="form-control"
            placeholder="Emails (Auto-filled)"
            value={emails}
            readOnly
          />
        </div>
        <div className="mb-1 mb-3">
          {" "}
          <input
            type="text"
            className="form-control"
            placeholder="Subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />
        </div>
        <div className="mb-1 mb-3">
          <textarea
            placeholder="Message"
            className="form-control"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </div>
        <div className="mb-1">
          <button className="btn btn-primary w-100 mt-3" onClick={sendEmails}>
            Send Emails
          </button>
        </div>
      </form>
    </div>
  );
};

export default SendBulkEmail;
